<template>
  <ReaderInterlude
    v-bind="$props"
    :cardClass
    @openComments="emit('openComments')"
  >
    <template #default v-if="$slots.return" class="tile space-y-4">
      <slot name="return"></slot>
      <NamiButton button-type="primary" @buttonClick="emit('return')" block
        >{{ $t("components.reader.interlude.button.return") }}
      </NamiButton>
    </template>
    <template #share><slot name="share"></slot></template>
    <template #comments><slot name="comments"></slot></template>
  </ReaderInterlude>
</template>

<script setup lang="ts">
defineProps<{ cardClass?: string }>();

const emit = defineEmits<{
  (e: "return"): void;
  (e: "openComments"): void;
}>();
</script>
